<template>
	<div class="home-block">
		<div class="d-flex align-items-center mb-3">
			<font-awesome-icon :icon="['fal', 'file-contract']" class="mr-2 icon-groomy-red" />
			<h3 class="mb-0 mr-auto">{{ $t('monte.contract_list') }}</h3>
			<b-button variant="primary" size="sm" :to="{ name: 'ContractNew' }" tag="router-link">
				{{ $t('action.ajouter_contract') }} <font-awesome-icon :icon="['fal', 'plus']" />
			</b-button>
		</div>

		<div v-if="busy" class="text-center py-3">
			<LoadingSpinner />
		</div>
		<EmptyState v-else-if="contracts.length === 0" :label="$t('global.empty_state_default')" />
		<div v-else>
			<div
				v-for="contract in contracts"
				:key="contract.contract_id"
				class="d-flex align-items-center py-2 border-bottom"
				:style="contract.mare_id ? 'cursor:pointer' : ''"
				@click="contract.mare_id && goToContract(contract)"
			>
				<div class="flex-fill min-w-0 overflow-hidden">
					<div class="text-truncate">
						<strong>{{ contract.mare_nom }}</strong>
						<span v-if="contract.stallion_nom" class="text-muted"> × {{ contract.stallion_nom }}</span>
					</div>
					<small class="d-block text-truncate text-muted">{{ contract.contract_num }} · {{ contract.season_label }} · {{ contract.avenant_status }}</small>
				</div>
				<font-awesome-icon v-if="contract.mare_id" :icon="['fal', 'chevron-right']" class="text-muted ml-2 flex-shrink-0" />
			</div>
		</div>

		<div class="text-center mt-3">
			<b-button variant="secondary" :to="{ name: 'ContractList' }" tag="router-link">
				{{ $t('monte.voir_tous_contrats') }}
				<b-badge v-if="total > 0" variant="primary" class="ml-1">{{ total }}</b-badge>
			</b-button>
		</div>
	</div>
</template>

<script>
import ContractMixin from '@/mixins/Contract.js'
import Vue from 'vue'

export default {
	name: 'HomeContracts',
	mixins: [ContractMixin],
	data() {
		return {
			all_contracts: [],
			busy: false,
		}
	},
	computed: {
		/** 8 contrats les plus récents (tri saison desc par season_start, puis contract_num) */
		contracts() {
			return this.all_contracts.slice().sort((a, b) => {
				const sa = a.season_start || a.season_label || ''
				const sb = b.season_start || b.season_label || ''
				if (sb !== sa) return sb > sa ? 1 : -1
				const da = a.contract_created ? new Date(a.contract_created) : new Date(0)
				const db = b.contract_created ? new Date(b.contract_created) : new Date(0)
				return db - da
			}).slice(0, 8)
		},
		total() {
			return this.all_contracts.length
		},
	},
	async mounted() {	
		this.busy = true
		const raw = await this.getContractByTiers()
		this.all_contracts = raw.map(c => ({
			contract_id:    c.contract_id,
			contract_num:   c.contract_num == null ? Vue.i18n.translate('monte.contrat_brouillon_non_numerote') : c.contract_num,
			contract_created: c.contract_created || null,
			mare_id:        c.mare_id,
			mare_nom:       c.mare_nom,
			stallion_nom:   c.stallion_nom,
			season_label:   c.season_label,				
			season_start:   c.season ? c.season.season_start : null,
			avenant_status: this.getTrad(c.avenant_status),
		}))
		this.busy = false
	},
	methods: {
		goToContract(contract) {
			this.$router.push({ name: 'ContractMareFiche', params: { horse_id: contract.mare_id, contract_id: contract.contract_id } }).catch(() => {})
		},
	},
	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		EmptyState:     () => import('@/components/EmptyState'),
	},
}
</script>
